import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'plan_details',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'register_insurance_plan' })
  }
}
